import * as React from "react";
import EventDefinitionName from "views/components/widgets/events/filters/EventDefinitionName";
import EventDefinitionFilter from "views/components/widgets/events/filters/EventDefinitionFilter";
import EventTypeFilter from "views/components/widgets/events/filters/EventTypeFilter";
import EventPriorityFilter from "views/components/widgets/events/filters/EventPriorityFilter";
import PriorityName from "components/events/events/PriorityName";
const filterComponents = [
  {
    configuration: (selectedValues, editValue, onChange) => /* @__PURE__ */ React.createElement(
      EventDefinitionFilter,
      {
        value: editValue,
        onSelect: (newValue) => onChange(newValue),
        selectedValues
      }
    ),
    attribute: "event_definition_id",
    renderValue: (value) => /* @__PURE__ */ React.createElement(EventDefinitionName, { eventDefinitionId: value, displayAsLink: false }),
    allowMultipleValues: true
  },
  {
    attribute: "alert",
    configuration: (selectedValues, _editValue, onChange) => /* @__PURE__ */ React.createElement(EventTypeFilter, { onSelect: onChange, selectedValues }),
    renderValue: (isAlert) => isAlert === "true" ? "Alert" : "Event"
  },
  {
    attribute: "priority",
    configuration: (selectedValues, _editValue, onChange) => /* @__PURE__ */ React.createElement(EventPriorityFilter, { onSelect: onChange, selectedValues }),
    renderValue: (priority) => /* @__PURE__ */ React.createElement(PriorityName, { priority })
  }
];
export default filterComponents;
